const store = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    }
}

export default store
